<template>
  <MessageWelcomeContainer>
    <MessageWelcomeTitle
      v-for="msg in defaultMessages"
      :key="msg"
    >
      {{ msg }}
    </MessageWelcomeTitle>

    <QuickConversationCandidateResponses class="tw:flex-col tw:@md:justify-center tw:@md:flex-row tw:@md:flex-wrap" />

    <QuickConversationPromptInput class="tw:px-0" />
  </MessageWelcomeContainer>
</template>

<script setup>
import { MessageWelcomeContainer, MessageWelcomeTitle } from '@/components/common/message'
import QuickConversationCandidateResponses from './quick-conversation-candidate-responses.vue'
import QuickConversationPromptInput from './quick-conversation-prompt-input.vue'
import { useQuickConversation } from './use-quick-conversation.js'

const { defaultMessages } = useQuickConversation()
</script>
